import { useRef } from 'react';

import { useIsomorphicLayoutEffect } from '@/shared/hooks/useIsomorphicLayoutEffect';

const overlays: symbol[] = [];

/** Escape закрывает верхний оверлей. Capture-фаза — чтобы опередить экраны. */
export function useOnEscape(active: boolean, handler: () => void): void {
  const handlerRef = useRef(handler);
  useIsomorphicLayoutEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useIsomorphicLayoutEffect(() => {
    if (!active) return;
    const overlay = Symbol();
    overlays.push(overlay);
    const onKeyDown = (event: KeyboardEvent): void => {
      if (event.key !== 'Escape' || overlays[overlays.length - 1] !== overlay) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      handlerRef.current();
    };
    document.addEventListener('keydown', onKeyDown, true);
    return () => {
      document.removeEventListener('keydown', onKeyDown, true);
      const index = overlays.lastIndexOf(overlay);
      if (index !== -1) overlays.splice(index, 1);
    };
  }, [active]);
}
